<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
// 全局全屏 loading 已移除：登录页改用按钮 loading，
// 后台的加载遮罩放在 layouts 的内容区里，只覆盖主区域。
export default {
  name: 'App',
  data() {
    return {}
  }
}
</script>

